// ── The RGS providers ──
//
// ONE import, because this game ships ONE provider. Settings.APP.RGS_PROVIDER
// is "PopiPlay" and the deployed repo contains only that folder — Dmon,
// PixUpPlay and Redstone exist in this working copy but are not part of the
// game that is built.
//
// This used to be a `require.context` sweep of ./ for every provider's RGS.js.
// It had to go because `require.context` is a WEBPACK api: under Jest this
// module threw on import and took the suites that reach a provider down with
// it. The first replacement imported all four folders by name and broke the CI
// build instead — the sweep had been quietly tolerating providers that are not
// there.
//
// So: name the one that is.
import PopiPlay from "./PopiPlay/RGS";

// Keyed by FOLDER NAME, which is what Settings.APP.RGS_PROVIDER holds.
const providers = {
  PopiPlay,
};

export default providers;
